export const messages = {
  en: {
    wechatSubscribe: {
      title: 'Subscribed Users',
      type: 'Type',
      openId: 'Open ID',
      unionId: 'Union ID',
      syncTime: 'Sync Time',
      wechat: 'WeChat',
      other: 'Other',
      syncUser: 'Sync Users',
      confirmTitle: 'Please confirm your operation!',
      syncConfirmText: 'Confirm to sync subscribed users data from WeChat official account. Please do not use frequently to avoid being banned by WeChat. Please refresh to view sync records after submission.',
      syncSuccess: 'Sync successfully',
      syncError: 'Sync failed',
      fetchError: 'Failed to fetch subscribed users',
      avatar: 'Avatar',
      name: 'Name',
      userName: 'Name',
      userId: 'User ID',
      identityType: 'Identity',
      phone: 'Phone',
      remark: 'Remark',
      tagidList: 'Tags',
      editTitle: 'Edit Subscriber',
      nickname: 'Nickname',
      updateError: 'Failed to update'
    }
  },
  zh: {
    wechatSubscribe: {
      title: '关注用户',
      type: '类型',
      openId: 'Open ID',
      unionId: 'Union ID',
      syncTime: '同步时间',
      wechat: '微信',
      other: '其他',
      syncUser: '同步用户',
      confirmTitle: '请确认您的操作!',
      syncConfirmText: '确定从公众号同步关注用户数据，请不要频繁使用，以免微信公众号封禁，提交后请刷新查看同步记录',
      syncSuccess: '同步成功',
      syncError: '同步失败',
      fetchError: '获取关注用户失败',
      avatar: '头像',
      name: '姓名',
      userName: '姓名',
      userId: '用户ID',
      identityType: '身份',
      phone: '手机号',
      remark: '用户备注',
      tagidList: '用户标签',
      editTitle: '编辑关注用户',
      nickname: '用户备注',
      updateError: '更新失败'
    }
  }
}